export enum ERoles {
  STORE = 'STORE',
  STATS = 'STATS',
  VALIDATOR = 'VALIDATOR',
}
